import React, { useRef } from "react";
import PropTypes from "prop-types";
import { FaSearch } from "react-icons/fa";

const SearchInput = ({ searchQuery, setSearchQuery , placeholder}) => {
  const inputRef = useRef(null);

  return (
    <div
      className="mb-6 relative"
      style={{
        width: "100%",
        maxWidth: "600px",
        margin: "0 auto",
        display: "flex",
        justifyContent: "flex-end",
        position: "relative",
      }}
    >
      <input
        ref={inputRef}
        type="text"
        placeholder={placeholder}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        style={{
          width: "100%",
          opacity: 1,
          padding: "10px 40px 10px 15px",
          borderRadius: "15px",
          border: "1px solid #ccc",
        }}
      />

      <FaSearch
        className="text-gray-600 cursor-pointer"
        size={20}
        style={{
          position: "absolute",
          right: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 2,
        }}
      />
    </div>
  );
};

SearchInput.propTypes = {
  searchProduct: PropTypes.string.isRequired,
  setSearchProduct: PropTypes.func.isRequired,
};

export default SearchInput;
